/**
 * Created by eriksundqvist on 25/05/16.
 */
import { connect } from 'react-redux';
import WorkDatePicker from './work-date-picker';

function mapStateToProps (state) {
  return {
    locale: state.i18n.locale
  };
};

export default connect(mapStateToProps)(WorkDatePicker);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/work-date/work-date-picker-container.js
 **/